const SUMMARY_SECTION_V_F_MODAL = 'SUMMARY_SECTION_V_F_MODAL';

export {
  SUMMARY_SECTION_V_F_MODAL,
};

